export const getLocationFromIP = () => {
    return fetch('https://ipapi.co/json/')
    .then( res => res.json())
    .then(response => {
        return response;        
    })
    .catch((error) => {
        console.error('Error:', error);
    } )
}